import { reactive, computed } from 'vue'
import ru from '../locales/ru.js'
import en from '../locales/en.js'

// Получаем сохраненный язык или используем язык браузера
const savedLocale = localStorage.getItem('app-locale')
const browserLocale = navigator.language.split('-')[0]
const defaultLocale = savedLocale || (browserLocale === 'ru' ? 'ru' : 'en')

// Реактивное состояние для текущего языка
const state = reactive({
  locale: defaultLocale,
  messages: { ru, en }
})

// Функция перевода
export function t(key) {
  // Специальный случай - получение текущей локали
  if (key === 'locale') {
    return state.locale
  }
  
  const keys = key.split('.')
  let value = state.messages[state.locale]
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k]
    } else {
      return key // Возвращаем ключ, если перевод не найден
    }
  }
  
  return value || key
}

// Установка языка
export function setLocale(newLocale) {
  if (state.messages[newLocale]) {
    state.locale = newLocale
    localStorage.setItem('app-locale', newLocale)
    document.documentElement.setAttribute('lang', newLocale)
  }
}

// Переключение языка
export function toggleLocale() {
  const newLocale = state.locale === 'ru' ? 'en' : 'ru'
  setLocale(newLocale)
}

// Получение текущего языка (реактивное)
export function useLocale() {
  return computed(() => state.locale)
}

// Глобальный плагин для Vue
export default {
  install(app) {
    // Глобальный метод $t
    app.config.globalProperties.$t = t
    
    // Глобальное свойство $locale
    app.config.globalProperties.$locale = computed(() => state.locale)
    
    // Provide для composition API
    app.provide('i18n', {
      t,
      locale: computed(() => state.locale),
      setLocale,
      toggleLocale
    })
  }
}

